<template>
    <v-container fluid fill-height>
        <v-data-table
            :headers="headers"
            :items="$store.state.posts"
            class="elevation-5"
            :sort-by="['publishing_date_from', 'id']"
            :sort-desc="[true, true]"
            loading-text="Loading... Please wait"
            :loading="isPostLoading"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Posts</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn class="mx-2 mt-3" to="/posts/new" fab dark color="#E6007E">
                        <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:item.online="{ item }">
                <v-chip
                        class="ma-2"
                        color="green"
                        text-color="white"
                        v-if="item.is_live == 1"
                >
                    <v-avatar left>
                        <v-icon>mdi-check-network</v-icon>
                    </v-avatar>
                    Online
                </v-chip>

                <v-chip
                        class="ma-2"
                        color="red"
                        text-color="white"
                        v-else
                >
                    <v-avatar left>
                        <v-icon>mdi-close-network</v-icon>
                    </v-avatar>
                    Offline
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    export default {
        name: 'Posts',
        beforeCreate () {
          this.$store.dispatch('fetchCategories');
        },
        mounted() {
          this.$store.dispatch('fetchPosts');
          this.refreshTimeout = setTimeout(()=> {
            this.$store.dispatch('fetchPosts');
          },15000)
          this.$forceUpdate();
        },
      beforeDestroy () {
        clearTimeout(this.refreshTimeout);
      },
      computed:{
          isPostLoading(){
            return this.$store.getters.postsLoading;
          },
          totalPosts(){
            return this.$store.getters.totalPosts;
          }
        },
      watch:{

      },
        data: () => {
            return {
              refreshTimeout: null,
              page: 1,
              pageCount: 0,
              itemsPerPage: 25,
              headers: [
                  {text: 'Online', value: 'online', sortable: false, width:'20px'},
                  {text: 'ID',align: 'start', value:'id'},
                  {
                      text: 'Title',
                      sortable: false,
                      value: 'blog_title',
                  },
                  {text: 'Veröffentlicht am', value: 'publishing_date_from'},
                  {text: 'Kategorie', value: 'category_name'},
                  {text: 'Typ', value: 'type'},
                  {text: 'Actions', value: 'actions', sortable: false },
              ]
            }
        },
        methods:{
            editItem (item) {
              this.$store.dispatch('checkTime',item.publishing_date_from)
              if(this.$store.getters.allowedToEdit){
                this.$store.dispatch('setPostToEdit',item);
                this.$router.push({path:'/posts/edit'});
              }else{
                this.$store.dispatch('ask', {
                  title: 'Really Destroy Cache System?',
                  body: 'This would suck, dude! Don\'t be so mad!',
                  advancedDialog: true
                }).then(confirmation => {
                  if(confirmation){
                    alert('We know that you would do it. But we don\'t allow it. Live with it.');
                  }
                })
              }
            },

            deleteItem (item) {
              const index = this.$store.state.posts.indexOf(item);
              this.$store.dispatch('ask', {
                title: 'Löschung eines Posts',
                body: 'Bist du dir sicher das du diesen Post löschen möchtest?\nDer Post ist NICHT wiederherstellbar',
                advancedDialog: true
              }).then(confirmation => {
                if(confirmation){
                  this.$store.dispatch('deletePost',this.$store.state.posts[index]['id']);
                  this.$store.state.posts.splice(index, 1);
                }
              });
            },
        },
    }
</script>

<style scoped>
    .container.fill-height{
        align-items: normal;

    }

    .v-data-table.elevation-5.theme--light{
        width: inherit;
    }
</style>